import { Button, Classes, Dialog } from "@blueprintjs/core";
import React from "react";

import { DialogResultButtonType, useDialogData } from "../contexts";
import { useTl } from "../hooks";
import { ETLCodes } from "../locales";

export const DialogRoot: React.FunctionComponent = () => {
  const { dialogData, hideDialog } = useDialogData();

  const isShown = React.useMemo(() => {
    return !!dialogData;
  }, [dialogData]);
  const { t } = useTl();
  const message = dialogData ? dialogData.message : "";
  const title = dialogData ? dialogData.title || t(ETLCodes.Confirm) : "";

  const finalButtons = React.useMemo<DialogResultButtonType[]>(() => {
    if (dialogData?.buttons) return dialogData.buttons;
    return [
      {
        intent: "danger",
        text: t(ETLCodes.No),
        resultType: "no",
      },
      {
        intent: "success",
        text: t(ETLCodes.Yes),
        resultType: "yes",
      },
    ];
  }, [dialogData, t]);

  return (
    <Dialog
      isOpen={isShown}
      title={title}
      className={""}
      canOutsideClickClose={true}
      onClose={() => {
        hideDialog("cancel");
      }}
    >
      <div className={Classes.DIALOG_BODY}>
        <p>{message}</p>
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          {finalButtons.map((bt) => {
            const { resultType, ...btProps } = bt;
            return (
              <Button
                key={resultType.toString()}
                {...btProps}
                onClick={() => hideDialog(resultType)}
              />
            );
          })}
        </div>
      </div>
    </Dialog>
  );
};
